import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLocation } from '../context/LocationContext';
import './AuthenticatedPage.css';

import LocationSelectionModal from '../components/LocationSelectionModal';
import ServicesSection from '../components/ServicesSection';
import Cart from '../components/Cart';
import Footer from '../components/Footer';
import Header from '../components/Header';


const AuthenticatedPage = () => {
  const { userPhone, logout } = useAuth();
  const { selectedLocation, isLocationSet } = useLocation();
  const navigate = useNavigate();
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  const handleLocationSet = () => {
    // Location has been set, modal will close automatically
    console.log('Location set successfully');
  };

  const handleLocationIconClick = () => {
    setIsLocationModalOpen(true);
  };

  const handleLocationModalClose = () => {
    setIsLocationModalOpen(false);
  };

  return (
    <div className="authenticated-page">
      <LocationSelectionModal 
        onLocationSet={handleLocationSet}
        isOpen={isLocationModalOpen || !isLocationSet}
        onClose={handleLocationModalClose}
      />
      <div className="authenticated-container">
        <Header rightContent={
          <div className="header-actions">
            <button
              className="location-icon-btn"
              onClick={handleLocationIconClick}
              title={isLocationSet && selectedLocation ? `${selectedLocation.cityName}, ${selectedLocation.apartmentName}` : 'Select Location'}
            >
              <span className="location-icon">📍</span>
              {isLocationSet && selectedLocation && (
                <span className="location-text-container">
                  <span className="location-text location-city">
                    {selectedLocation.cityName}
                  </span>
                  <span className="location-text location-apartment">
                    {selectedLocation.apartmentName}
                  </span>
                </span>
              )}
            </button>
            <button className="my-orders-btn" onClick={() => navigate('/my-orders')}>
              📦 My Orders
            </button>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </div>
        } />

        <main className="page-content">
          {/* <div className="welcome-card">
            <div className="welcome-icon">✓</div>
            <h2>Welcome to MYHELPZ!</h2>
            <p className="welcome-text">
              Select the service you need and we will get it done for you.
            </p>           
          </div> */}
          {/* <LocationSelector /> */}
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🏠</div>
              <h3>Home Services</h3>
              <p>Get help with all your home needs</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔧</div>
              <h3>Expert Help</h3>
              <p>Connect with qualified professionals</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Quick Response</h3>
              <p>Fast and reliable service delivery</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💬</div>
              <h3>Easy Communication</h3>
              <p>Stay connected via WhatsApp</p>
            </div>
          </div>
          <ServicesSection />
        </main>
      </div>
      <Cart />
      <Footer />
    </div>
  );
};

export default AuthenticatedPage;

